import { useContext } from 'react'
import { Button, Snackbar, Typography } from '@mui/material'

import { NotificationContext } from 'src/containers/notification-context'
import { useStyles } from './styles'
import { HelperWrapper } from '../helper-wrapper'

const NotificationBar = () => {
  const classes = useStyles()
  const { message, hide, timeout, onButtonClick, icon, isShown } = useContext(NotificationContext)

  return (
    <Snackbar
      open={isShown}
      autoHideDuration={timeout}
      onClose={hide}
      className={classes.notification}
      disableWindowBlurListener
    >
      <div className={classes.notificationWrapper}>
        <div className={classes.notificationMessageWrapper}>
          <div className={classes.iconWrapper}>{icon}</div>
          <Typography className={classes.notificationText}>{message}</Typography>
        </div>
        {onButtonClick && (
          <Button variant="outlined" onClick={onButtonClick}>
            <HelperWrapper t="notification-bar-cancel"></HelperWrapper>
          </Button>
        )}
      </div>
    </Snackbar>
  )
}

export { NotificationBar }
